// extracted by mini-css-extract-plugin
export default {"main":"MinimalLayout_main__rLsu5"};